module.exports = __webpack_public_path__ + "img/logo-sm.b639697d.png";